// extracted by mini-css-extract-plugin
module.exports = {"card":"ChangeEmailSuccess_card__2JAin","description":"ChangeEmailSuccess_description__3vsrg"};